import React from 'react';
import c from 'classnames';
import TierIcon from '@wix/da-ds/pkg/Icons/24x24/Tier';
import TierIconSmall from '@wix/da-ds/pkg/Icons/16x16/Tier';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { useSubscribeButton } from '../useSubscribeButton';
import s from './Subscribe.scss';
const SubscribeVariant = ({ tier, withPrice = false, size = 'medium', className, href })=>{
    const { onClick, biData, text } = useSubscribeButton(tier, {
        type: 'subscribe',
        withPrice
    });
    return /*#__PURE__*/ React.createElement(SolidButton, {
        isFakeButton: true,
        className: c(s['root'], className),
        icon: size === 'small' ? TierIconSmall : TierIcon,
        size: size,
        variant: "main",
        href: href,
        onClick: onClick,
        biData: biData
    }, text);
};
SubscribeVariant.displayName = 'SubscribeVariant';
export default SubscribeVariant;
